import { createSelector } from 'reselect'
import moment from 'moment'
import { getSchoolAssistants } from './actions'

export const getAssistant = createSelector(
  state => getSchoolAssistants(state),
  schoolAssistants => schoolAssistants.assistant
)

export const getAssistantProfileImage = createSelector(
  state => getSchoolAssistants(state),
  schoolAssistants => schoolAssistants.profileImage
)

export const getOptIn = createSelector(
  state => getSchoolAssistants(state),
  schoolAssistants => schoolAssistants.optin
)

export const schoolAssistantsMap = createSelector(
  state => getSchoolAssistants(state),
  schoolAssistants => {
    return Object.keys(schoolAssistants.assistants).map(k => {
      const assistant = schoolAssistants.assistants[k]

      return {
        ...assistant,
        speciality: assistant.schoolSpeciality?.id ?? null,
        birthdate: typeof assistant.birthdate === 'string'
          ? moment(assistant.birthdate).format('DD/MM/YYYY')
          : null
      }
    })
  }
)

export const schoolSpecialitiesMap = createSelector(
  state => getSchoolAssistants(state),
  schoolAssistants => {
    return Object.keys(schoolAssistants.schoolSpecialities).map(k => {
      const schoolSpeciality = schoolAssistants.schoolSpecialities[k]
      const { specialityYear } = schoolSpeciality

      return {
        id: schoolSpeciality.id,
        name: `${specialityYear.specialityAbbreviation} (${specialityYear.studyYearName})`,
        nameTitle: specialityYear.specialityName,
        specialityYear
      }
    })
  }
)
